module.exports = __webpack_public_path__ + "img/article-image-1.57446c43.jpg";